// Import model
import { ObjectFieldOptions } from '../models/ObjectFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)
import { Form } from '../models/Form';

// Import dependency serializers (for complex types)
import { FormSerializer } from './FormSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class ObjectFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a ObjectFieldOptions instance
   */
  static deserialize(json: string): ObjectFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectFieldOptions instance
   */
  static fromObject(obj: any): ObjectFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectFieldOptions');
    }


    const instance: ObjectFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      objectType: obj['ObjectType'] as string,
      objectTypeName: obj['ObjectType|Name'] as string | undefined,
      addFormUrls: obj['AddFormUrls'] as string | undefined,
      editForm: obj['EditForm'] ? FormSerializer.fromObject(obj['EditForm']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectFieldOptions instances
   */
  static deserializeArray(json: string): ObjectFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectFieldOptions instance to a JSON string
   */
  static serialize(instance: ObjectFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectFieldOptions instance to a plain object
   */
  static toObject(instance: ObjectFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'ObjectType': instance.objectType,
      'ObjectType|Name': instance.objectTypeName,
      'AddFormUrls': instance.addFormUrls,
      'EditForm': instance.editForm ? FormSerializer.toObject(instance.editForm) : undefined,
    };
  }

  /**
   * Serializes an array of ObjectFieldOptions instances to a JSON string
   */
  static serializeArray(instances: ObjectFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
